import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, UrlModule } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';
import { CustomProductItemModule } from "../../../../../../custom/cms-components/content/custom-product-item/custom-product-item.module";
import { CustomCarouselModule } from '../../../../shared/components/custom-carousel/custom-carousel.module';
import { CustomAddToCartModule } from '../../../cart/custom-add-to-cart/custom-add-to-cart.module';
import { CustomProductCarouselComponent } from './custom-product-carousel.component';

@NgModule({
  declarations: [CustomProductCarouselComponent],
  exports: [CustomProductCarouselComponent],
  imports: [
    CommonModule, MediaModule, RouterModule, UrlModule,
    CustomCarouselModule,
    CustomAddToCartModule,
    CustomProductItemModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductCarouselComponent: {
          component: CustomProductCarouselComponent,
        },
      },
    } as CmsConfig),
  ]
})
export class CustomProductCarouselModule {
}
